module.exports = __webpack_public_path__ + "static/media/Example of Employees.3383eec7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Employees.csv
// module id = 712
// module chunks = 0